import React, { memo } from "react";

import GridColumn from "../../components/grid/GridColumn";
import GridHeaderRow from "../../components/grid/GridHeaderRow";
import GridFilterRow from "./GridFilterRow";

interface GridHeaderProps<T> {
    columns: GridColumn<T>[];

    filters: Map<string, any>;
    sortField: string;
    fixedHeader?: boolean;
    globalFilter: boolean;
    bulkEdit?: boolean;
    bulkAll: boolean;
    blockSort?: boolean;

    onClick?: (column: GridColumn<T>) => void;
    onClearFilters: () => void;
    filterChanged: (field: string, value: any) => void;
    onSelectAllChanged?: (value: boolean) => void;
}

class GridHeader<T> extends React.Component<GridHeaderProps<T>> {
    showFilters() {
        return (
            this.props.globalFilter ||
            this.props.columns.some(column => column.filterable)
        );
    }

    render(): React.ReactNode {
        return (
            <thead className={this.props.fixedHeader ? "fixed-header" : ""}>
                <GridHeaderRow
                    columns={this.props.columns}
                    sortField={this.props.sortField}
                    bulkEdit={this.props.bulkEdit}
                    bulkAll={this.props.bulkAll}
                    blockSort={this.props.blockSort}
                    onClick={this.props?.onClick}
                    onSelectAllChanged={this.props.onSelectAllChanged}
                />
                {this.showFilters() ? (
                    <GridFilterRow
                        columns={this.props.columns}
                        filters={this.props.filters}
                        globalFilter={this.props.globalFilter}
                        filterChanged={this.props.filterChanged}
                        onClearFilters={this.props.onClearFilters}
                    />
                ) : null}
            </thead>
        );
    }
}

export default memo(GridHeader);
